import React from 'react';
import { Link as GatsbyLink } from 'gatsby';

export default ({
  noNewTab = false,
  children,
  href,
  onClick,
  to,
  style = {},
  timeout = 150,
  ...props
}) => {
  if (!href && !to) throw new Error('<Link /> requires an href or to prop');
  return href ? (
    <a
      href={href}
      style={{ textDecoration: 'none', color: 'inherit', ...style }}
      target={noNewTab ? undefined : '_blank'}
      rel="noopener noreferrer"
      onClick={e => {
        if (onClick) {
          e.preventDefault();
          onClick();
          setTimeout(() => {
            return true;
          }, timeout);
          window.location = href;
        } else {
          return true;
        }
      }}
      {...props}
    >
      {children}
    </a>
  ) : (
    <GatsbyLink
      to={to}
      style={{ textDecoration: 'none', color: 'inherit', ...style }}
      {...props}
    >
      {children}
    </GatsbyLink>
  );
};
